// 适配脚本：移动端跟随视口缩放；平板 / 电脑固定根字号，避免 px 被 rem 放大导致溢出与遮挡
// 设计稿基准 375px（postcss-pxtorem rootValue: 37.5）
// 三档断点：手机 ≤768 ｜ 平板 769~1024 ｜ 电脑 ≥1025
//   - 手机：根字号随视口缩放（移动优先，375 设计稿对应 37.5px）
//   - 平板 / 电脑：固定根字号，使 @media 内的 px 按真实像素渲染，不被放大
// 注意：DOM 结构切换（home.vue 的 $isPC / $isMobile）仍由 main.js 的 768 分界控制，
//       平板复用 PC 横向菜单 DOM，此处只控制根字号缩放比例。
(function () {
  const DESIGN_WIDTH = 375
  const DESIGN_FONT = 37.5 // DESIGN_WIDTH / 10
  const TABLET_MAX = 1024  // 平板上限（含）；≥1025 视为电脑
  const MIN_WIDTH = 320

  function setRootFontSize () {
    const docEl = document.documentElement
    // 必须用 window.innerWidth（与 deviceDetector / main.js 的 $isPC 同源同阈值 768），
    // 不能用 documentElement.clientWidth：两者在 768 临界点相差约 15px（滚动条宽度），
    // 会出现「PC 布局 + 移动端放大根字号」的字号爆炸（曾出现根字号 75.6px 的 bug）。
    const clientWidth = window.innerWidth || docEl.clientWidth || DESIGN_WIDTH

    let fontSize
    if (clientWidth <= 768) {
      // 手机：根字号随视口缩放
      const w = Math.max(clientWidth, MIN_WIDTH)
      fontSize = (w / DESIGN_WIDTH) * DESIGN_FONT
    } else if (clientWidth <= TABLET_MAX) {
      // 平板：固定根字号，px 按真实像素渲染（不被放大导致溢出）
      fontSize = DESIGN_FONT
    } else {
      // 电脑：固定根字号
      fontSize = DESIGN_FONT
    }

    docEl.style.fontSize = fontSize + 'px'
    // 暴露给可能依赖的脚本
    docEl.dataset.rem = String(fontSize)
  }

  setRootFontSize()

  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(setRootFontSize, 200)
  })
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) setRootFontSize()
  })
})()
